<script setup lang="ts">
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const emit = defineEmits(["change"]);

const props = defineProps<{
  extensions?: string[];
}>();

const fileName = ref(null);
const dragging = ref(false);

const accepts = computed(() => props.extensions?.join(",") || "");

function readFile(file: any) {
  const reader = new FileReader();
  reader.onload = () => {
    const infos = reader?.result?.split(",")[0];
    const base64String = reader?.result?.split(",")[1];
    const fileExtension = file.name.split(".").pop();
    fileName.value = file.name;

    emit("change", {
      name: file.name,
      infos: infos,
      extension: fileExtension,
      file: base64String,
      size: file.size,
    });
  };
  reader.readAsDataURL(file);
}

function fileSelect(event: any) {
  const files = event?.target?.files;
  if (files.length > 0) {
    readFile(files[0]);
  }
}

function fileDrop(event: any) {
  dragging.value = false;
  const droppedFiles = event.dataTransfer.files;
  if (droppedFiles.length > 0) {
    readFile(droppedFiles[0]);
  }
}
</script>

<template>
  <div class="base-file">
    <div
      class="drop-area"
      :class="{ dragging: dragging }"
      @dragover.prevent
      @dragenter.prevent="dragging = true"
      @dragleave.prevent="dragging = false"
      @drop.prevent="fileDrop"
      @click="$refs.fileInput.click()"
    >
      {{ fileName ? fileName : t("common.texts.file_upload") }}
    </div>
    <input ref="fileInput" type="file" @change="fileSelect" :accept="accepts" />
  </div>
</template>

<style lang="scss" scoped>
.base-file {
  display: flex;
  flex-direction: column;

  input {
    display: none;
  }

  .file-drop {
    position: relative;
  }

  .drop-area {
    border: 2px dashed #ccc;
    padding: 1.5rem;
    text-align: center;
    cursor: pointer;
  }

  .drop-area.dragging {
    border-color: #666;
  }
}
</style>